module.exports = __webpack_public_path__ + "img/sekerTop.699ff1b7.png";